import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40d9fdd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-modal-media-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "frisbuy-modal-media-list__play-icon"
}
const _hoisted_5 = {
  key: 0,
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "24",
  r: "16",
  fill: "#212121",
  "fill-opacity": "0.2"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { opacity: "0.8" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M28.1192 22.7772C28.8701 23.2446 28.8701 24.4239 28.1192 24.8912L22.6451 28.2979C21.8999 28.7616 20.9727 28.1756 20.9727 27.2409L20.9727 20.4276C20.9727 19.4928 21.8999 18.9068 22.6451 19.3706L28.1192 22.7772Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M34.125 24.0005C34.125 18.4083 29.5921 13.8744 24 13.8742C18.4076 13.8742 13.8737 18.4081 13.8737 24.0005C13.8739 29.5926 18.4078 34.1255 24 34.1255C29.592 34.1252 34.1248 29.5925 34.125 24.0005ZM36.7917 24.0005C36.7914 31.0652 31.0647 36.7919 24 36.7922C16.935 36.7922 11.2073 31.0654 11.207 24.0005C11.207 16.9354 16.9349 11.2075 24 11.2075C31.0649 11.2078 36.7917 16.9355 36.7917 24.0005Z",
    fill: "white"
  })
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "20",
  cy: "20",
  r: "12",
  fill: "#212121",
  "fill-opacity": "0.2"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { opacity: "0.8" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.0864 19.0829C23.6497 19.4335 23.6497 20.3179 23.0864 20.6684L18.9809 23.2234C18.422 23.5712 17.7266 23.1317 17.7266 22.4307L17.7266 17.3207C17.7266 16.6196 18.422 16.1801 18.9809 16.528L23.0864 19.0829Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M27.5947 20.0004C27.5947 15.8062 24.1951 12.4058 20.001 12.4056C15.8067 12.4056 12.4062 15.8061 12.4062 20.0004C12.4064 24.1945 15.8068 27.5941 20.001 27.5941C24.195 27.5939 27.5945 24.1944 27.5947 20.0004ZM29.5947 20.0004C29.5945 25.2989 25.2995 29.5939 20.001 29.5941C14.7023 29.5941 10.4064 25.299 10.4062 20.0004C10.4062 14.7015 14.7021 10.4056 20.001 10.4056C25.2997 10.4058 29.5947 14.7016 29.5947 20.0004Z",
    fill: "white"
  })
], -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import widgetTypes from "@/common/consts/widgetTypes";
import { imageWithPostId } from "../interfaces";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupReviewMediaList',
  props: {
    mediaList: {},
    selectedMediaThumbnailUrl: {},
    playIconVariant: {}
  },
  emits: ["selectMedia"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.STORY);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.mediaList, (media, idx) => {
      return (_openBlock(), _createElementBlock("li", {
        key: idx,
        class: _normalizeClass(["frisbuy-modal-media-list__item", {
        'frisbuy-modal-media-list__item--selected':
          props.selectedMediaThumbnailUrl &&
          media.thumbnailUrl === props.selectedMediaThumbnailUrl,
      }]),
        onClick: () => emit('selectMedia', media)
      }, [
        _createElementVNode("img", {
          class: "frisbuy-modal-media-list__image",
          src: _unref(DomainSubstitute)(media.thumbnailUrl),
          onError: errorImageHandler
        }, null, 40, _hoisted_3),
        (media.videoUrl.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              (props.playIconVariant === 'mobileSheet')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_8))
                : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_12))
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})